// authModalService.js

import React from "react";
import { createRoot } from "react-dom/client";
import AuthModal from "./authmodal";

let root = null;
let container = null;

function cleanupAuthModalDom() {
  try {
    if (root) {
      root.unmount();
    }
  } catch (_e) {
    /* ignore */
  }
  root = null;
  try {
    if (container && container.parentNode) {
      container.remove();
    }
  } catch (_e) {
    /* ignore */
  }
  container = null;
}

export const openAuthModal = (options = {}) => {
  return new Promise((resolve) => {
    let settled = false;

    const finish = (value) => {
      if (settled) return;
      settled = true;
      cleanupAuthModalDom();
      resolve(value);
    };

    // Replace any lingering modal DOM (ensure React root torn down before removing nodes)
    if (container || root) {
      cleanupAuthModalDom();
    }

    // Create DOM node
    container = document.createElement("div");
    document.body.appendChild(container);

    root = createRoot(container);

    const handleClose = () => {
      finish({ Success: 0, success: false, cancelled: true });
    };

    const handleSubmit = (data) => {
      finish(data);
    };

    root.render(
      <AuthModal
        show={true}
        onClose={handleClose}
        onSubmit={handleSubmit}
        {...options}
      />,
    );
  });
};
